import * as types from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case types.CHANGE_PAGE:
      return Object.assign({}, state, {
        selectedPage: action.page,
        headerStyle: action.headerStyle
      })
    case types.LOAD_CONTENT_STARTED:
      return Object.assign({}, state, {
        inProgress: true,
      })
    case types.CONTENT_LOADED:
      return Object.assign({}, state, {
        inProgress: false,
        contentLoaded: true,
        ...action.payload
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/page-reducer.js